"use strict";

exports.__esModule = true;
exports.default = void 0;
var _react = require("react");
const useStateWithCallback = (defaultValue, callback) => {
  const [state, setState] = (0, _react.useState)(defaultValue);
  const setStateWithCallback = (0, _react.useCallback)(value => setState(prevValue => {
    if (value !== prevValue) {
      if (callback) {
        callback(value);
      }
    }
    return value;
  }), [callback]);
  return [state, setStateWithCallback];
};
var _default = exports.default = useStateWithCallback;